import React from 'react';
export default function FancyArrowRight() {
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5.83 7.18 21.34 17.65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33203 16.166H25.8829",
    stroke: "currentColor",
    strokeWidth: "2.3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6676 16.166C20.4457 16.166 19.1193 24.3231 13.9824 24.3231",
    stroke: "currentColor",
    strokeWidth: "2.3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6593 16.1641C20.4374 16.1641 19.1193 7.67731 13.9824 7.67731",
    stroke: "currentColor",
    strokeWidth: "2.3",
    strokeLinecap: "round"
  }));
}